<template>
  <div style="padding: 1vw">
    <div style="display: flex; justify-content: space-between; align-items: flex-end; padding: 0 1vw">
      <div class="pageTitle">
        <h3 class="fw-bold" style="color: #000; font-size: 1.8rem">
          공지사항 보기
        </h3>
      </div>
      <div style="display: flex; align-items: center;"/>
    </div>

    <div class="py-4 container-fluid card" style="width: 98%; margin: 1vw">
    <div class="kdh_table_div table-responsive p-0">
      <div class="noticeWriteWrap">
        <div class="inputWrap">
          <span class="title">제목</span>
          <span class="content"> {{title}} </span>
        </div>
          <div class="inputWrap">
            <span class="title">작성자</span>
            <span class="content"> {{writer}} </span>
          </div>
          <div class="inputWrap">
            <span class="title">노출 대상</span>
            <div v-for="(item, i) in targetsList" :key="i">
              <label style="font-size: 17px; font-weight: 400;" :for="item.code+'M'" v-if="selectedTarget.indexOf(item.code) !== -1">{{ item.name }}</label>
              <label style="font-size: 17px; font-weight: 400;" v-if="i < selectedTarget.length - 1 ">/</label>
            </div>
          </div>
          <div class="inputWrap">
            <span class="title">진료 과목</span>
            <div v-for="(item, i) in selectedMedicalDept" :key="i">
              <label style="font-size: 17px; font-weight: 400;" :for="item + i" >{{ item }}</label>
              <label style="font-size: 17px; font-weight: 400;" v-if="i < selectedMedicalDept.length - 1 ">/</label>
            </div>
          </div>
          <div class="inputWrap">
            <span class="title">팝업 공지사항 여부</span>
            <div >
              <label style="font-size: 17px; font-weight: 400;">{{isPopupNotice?'팝업 등록 완료':''}}</label>
            </div>
          </div>
          <div class="inputWrap">
            <span class="title"> 작성 시각 </span>
            <span class="content"> {{convertDate(createAt)}} </span>
          </div>
          <div style="width: 90%; height: 1px; background-color: lightgray; margin-bottom: 20px;"></div>
          <div ref="contentDiv" class="contentDiv"></div>
          <div style="width: 90%; height: 1px; background-color: lightgray; margin-bottom: 20px;"></div>
          <div v-if="existingAttachments.length > 0" class="inputWrap" style="margin-top: 30px;">
            <span class="title"> 첨부파일 </span>
          </div>
          <div class="fileWrap" style="margin-top: 30px;">
            <div class="fileRow" v-for="(file, index) in existingAttachments" :key="index">
              <span class="title hoverPointer" @click="downloadExistingFile(file)">{{ file.fileName }}</span>
            </div>
          </div>
          <div class="buttonWrap">
            <router-link
              :to="`/certilife/notice/${noticeId}/edit`"
            >
              <button class="btn btn-primary">수정하기</button>
            </router-link>
            <router-link
              :to="`/certilife/notice/list`"
            >
              <button class="btn btn-primary">목록</button>
            </router-link>
          </div>
      </div>
    </div>
  </div>
</div>

</template>
<script>
import { decodeUtfText, convertDate, convertMedicalDept, } from "../utils/utils";
import { MedicalDept } from '@/utils/enums'
export default {
  name: "noticeRead",
  components: {
  },
  data() {
    return {
      noticeId: "", // 공지사항 고유 id
      title: "", // 제목
      content: "", // 본문
      createAt: "", // 작성 시각
      targetsList: [], // 노출 대상 로드
      selectedTarget: [], // 선택된 노출 대상
      writer: "", // 작성자
      attachments: [], // 첨부파일
      deptList: [],
      selectedMedicalDept: [],
      existingAttachments: [], // 기존에 업로드 되어 있던 첨부파일
      isPopupNotice:false,
    };
  },
  props: ["id"],
  async mounted() {
    this.noticeId = this.$route.params.id;
    await this.getDeptList();
    await this.getTargets();
    await this.getNotice();
  },
  methods: {
    // 과 목록 가져오기
    async getDeptList() {
      try {
        const response = await this.$apiInstance.get(`/items/medical/depts`);
        if(response.status === 200 || response.status === 201) {
          this.deptList = response.data.filter(item => item.code !== MedicalDept.COMMON);
        }
      } catch(error) {
        console.log(error);
      }
    },

    // 노출 대상 가져오기
    async getTargets() {
      try {
        const response = await this.$apiInstance.get(`/notices/targets/list`);
        if(response.status === 200 || response.status === 201) {
          this.targetsList = response.data;
        } 
      } catch (error) {
        console.log(error);
      }
    },

    // 공지사항 가져오기
    async getNotice() {
      try {
        const response = await this.$apiInstance.get(
        `/notices/${this.noticeId}`,
        )
        if(response.status === 200 || response.status === 201) {
          this.$refs.contentDiv.innerHTML = response.data.contents;
          this.title = response.data.title;
          this.writer = response.data.writer;
          this.createAt = response.data.createAt;
          this.selectedTarget = response.data.targets;
          this.isPopupNotice = response.data.isPopupNotice;
          response.data.medicalDept.forEach((item) => {
            this.selectedMedicalDept.push(convertMedicalDept(item));
          })
          if(response.data.fileUrls && response.data.fileUrls.length > 0) {
            for(const item of response.data.fileUrls) {
              const fileUrlArray = item.split("/");
              const obj = {};
              obj.fileName = decodeUtfText(fileUrlArray[fileUrlArray.length - 1]);
              obj.fileUrl = item;
              this.existingAttachments.push(obj);
            }
          }
        }
      } catch(error) {
        console.log(error);
      }
    },
     // 기존에 등록된 파일 다운로드
     downloadExistingFile(file) {
      const downloadLink = document.createElement("a");
      downloadLink.target = "_blank";
      downloadLink.href = file.fileUrl;
      downloadLink.download = file.fileName; 
      downloadLink.click();
    },

    // 수정 화면에서 첨부한 파일 다운로드
    downloadFile(file) {
      const downloadLink = document.createElement("a");
      downloadLink.target = "_blank";
      downloadLink.href = URL.createObjectURL(file);
      downloadLink.download = file.name; 
      downloadLink.click();
    },
    initContent() {
      this.content = "";
      this.title = "";
    },
    convertDate,
  },
};
</script>
